import { ResetPasswordForm } from "@/components/formik/auth/ResetPasswordForm.tsx";
import AuthLayout from "@/components/layouts/AuthLayout";

export const ResetPasswordView = () => {
  return (
    <div>
      <AuthLayout title="Verify your Email" subtitle="Enter OTP sent to Email">
        <ResetPasswordForm />
      </AuthLayout>
    </div>
  );
};
